/*
 * 管理系
 */
const System = () => {
  return import('@/pages/Admin/System')
}
const Account = () => {
  return import('@/pages/Admin/Account')
}
const AccountInvitations = () => {
  return import('@/pages/Admin/AccountInvitations')
}
const EditAgency = () => {
  return import('@/pages/Admin/EditAgency')
}
const EditAdvertiser = () => {
  return import('@/pages/Admin/EditAdvertiser')
}
const AgencyMargin = () => {
  return import('@/pages/Admin/AgencyMargin.vue')
}

// 地点グループ入稿
const PointGroupOperation = () => {
  return import('@/pages/Admin/EditPointGroup.vue')
}

// 配信リストターゲティング
const InventoryTargeting = () => {
  return import('@/pages/Admin/InventoryListTargeting')
}

// IPアドレス List ターゲティング
const IPRangeListTargeting = () => {
  return import('@/pages/Admin/IPRangeListTargeting')
}

// Menu
const Menu = () => {
  return import('@/pages/Admin/Menu')
}

// Theme
const Theme = () => {
  return import('@/pages/Admin/Theme')
}

// 予算承認
const AdminBudgetRequest = () => {
  return import('@/pages/Admin/Request/AdminBudgetRequest')
}

// 代理店マージン承認
const AdminAgencyMarginRequest = () => {
  return import('@/pages/Admin/Request/AdminAgencyMarginRequest')
}

// メニュー承認
const AdminMenuRequest = () => {
  return import('@/pages/Admin/Request/AdminMenuRequest')
}

// マップレポート承認
const AdminMapReportRequest = () => {
  return import('@/pages/Admin/Request/AdminMapReportRequest')
}

// マップレポート画面
const AdminMapReport = () => {
  return import('@/pages/Admin/Request/AdminMapReport')
}

// キャンペーン管理
const Campaign = () => {
  return import('@/pages/Admin/Campaign')
}

export const adminRoutes = [
  // システム管理
  {
    path: '/admin/system_owners',
    name: 'System',
    component: System,
    meta: { requireAuth: true },
  },
  // 代理店編集
  {
    path: '/admin/agencies',
    name: 'EditAgency',
    component: EditAgency,
    meta: { requireAuth: true },
  },
  // 広告主編集
  {
    path: '/admin/advertisers',
    name: 'EditAdvertiser',
    component: EditAdvertiser,
    meta: { requireAuth: true },
  },
  {
    path: '/admin/accounts',
    name: 'Accounts',
    component: Account,
    meta: { requireAuth: true },
  },
  {
    path: '/admin/accounts/invitations',
    name: 'AccountInvitations',
    component: AccountInvitations,
    meta: { requireAuth: true },
  },
  /*
   * 配信リストターゲティング画面への導線はログインしている相手によって異なる
   * ただし、使用するcomponentは同じ
   */
  // 配信リストターゲティング(system ownerがログインしている場合)
  {
    path: '/admin/inventory_list_targeting/system_owner',
    name: 'Inventory Targeting for system owner',
    component: InventoryTargeting,
    meta: { requireAuth: true },
  },
  // 配信リストターゲティング(代理店Adminの場合)
  {
    path: '/admin/inventory_list_targeting/agency',
    name: 'Inventory Targeting for agency',
    component: InventoryTargeting,
    meta: { requireAuth: true },
  },
  /*
   * IPアドレス リスト画面への導線はログインしている相手によって異なる
   * ただし、使用するcomponentは同じ
   */
  // IPアドレス リストターゲティング(system ownerがログインしている場合)
  {
    path: '/admin/ip_address_list_targeting/system_owner',
    name: 'IP Address List Targeting for system owner',
    component: IPRangeListTargeting,
    meta: { requireAuth: true },
  },
  // IPアドレス リストターゲティング(代理店Adminの場合)
  {
    path: '/admin/ip_address_list_targeting/agency',
    name: 'IP Address List Targeting for agency admin',
    component: IPRangeListTargeting,
    meta: { requireAuth: true },
  },
  // menu
  {
    path: '/admin/menu',
    name: 'Menu',
    component: Menu,
    meta: { requireAuth: true },
  },
  // theme
  {
    path: '/admin/theme',
    name: 'Theme',
    component: Theme,
    meta: { requireAuth: true },
  },
  // 地点グループ入稿編集
  {
    path: '/admin/point_groups/:ownerProfileId',
    name: 'Admin Point Group Operation',
    component: PointGroupOperation,
    meta: { requireAuth: true },
  },
  // 予算承認
  {
    path: '/admin/request/budget',
    name: 'Requested Budgets Operation',
    component: AdminBudgetRequest,
    meta: { requireAuth: true },
  },
  // 代理店マージン承認
  {
    path: '/admin/request/agency_margin',
    name: 'Requested Agency Margins Operation',
    component: AdminAgencyMarginRequest,
    meta: { requireAuth: true },
  },
  // メニュー承認
  {
    path: '/admin/request/menu',
    name: 'Requested Menus Operation',
    component: AdminMenuRequest,
    meta: { requireAuth: true },
  },
  // マップレポート管理(システムオーナーがログインしている場合)
  {
    path: '/admin/request/map_reports',
    name: 'Map Report Request Operation',
    component: AdminMapReportRequest,
    meta: { requireAuth: true },
  },
  // マップレポート画面(システムオーナーがログインしている場合)
  {
    path: '/admin/map_reports/:mapReportId',
    name: 'Map Report Operation',
    component: AdminMapReport,
    meta: { requireAuth: true },
  },
  // 代理店マージン管理(システムオーナーがログインしている場合)
  {
    path: '/admin/agency_margin/system_owner',
    name: 'agency margin for system owner',
    component: AgencyMargin,
    meta: { requireAuth: true },
  },
  // 代理店マージン管理(代理店adminがログインしている場合)
  {
    path: '/admin/agency_margin/agency',
    name: 'agency margin for agency admin',
    component: AgencyMargin,
    meta: { requireAuth: true },
  },
  // キャンペーン管理
  {
    path: '/admin/campaign',
    name: 'Campaign',
    component: Campaign,
    meta: { requireAuth: true },
  },
]
